import React, { useEffect, useState } from 'react';
import { assetActions } from 'actions/asset';
import ProgressBar from '../../../ProgressBar/ProgressBar';

type Props = {
  assetId: number;
  refreshToken?: number;
};

interface AssetPI {
  assetId: number;
  asset: string;
  piAverage: number;
  piCritical: number;
}

const PerformanceIndicator: React.FC<Props> = ({
  assetId,
  refreshToken = 0,
}) => {
  const [performance, setPerformance] = useState<AssetPI | null>(null);
  const refreshData = refreshToken > 0;

  useEffect(() => {
    if (!assetId || assetId <= 0) return;
    let cancelled = false;
    assetActions()
      .getAssetPerformanceIndicator(assetId, refreshData)
      .then((data) => {
        if (!cancelled) {
          setPerformance(data);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setPerformance(null);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [assetId, refreshToken, refreshData]);

  if (!assetId || assetId <= 0) return null;
  if (!performance) return null;
  if (performance.piAverage === 0 && performance.piCritical === 0) {
    return (
      <div className="pi-container">
        No Performance Indicator data available
      </div>
    );
  }

  return (
    <div className="pi-container">
      <ProgressBar
        label="PI Average"
        value={performance.piAverage}
        tooltip="Performance Indicator Average"
      />
      <ProgressBar
        label="PI Critical"
        value={performance.piCritical}
        tooltip="Performance Indicator Critical"
      />
    </div>
  );
};

export default PerformanceIndicator;
